module.exports = __webpack_public_path__ + "img/ski-equipment.41288368.png";